import { NftInfo } from "@glow/shared";
import React from "react";
import { SquareNftImage } from "./SquareNftImage";

const SHOWN_NFTS_COUNT = 2;

export const NftStack = ({
  nfts,
  size,
  hovered = false,
}: {
  nfts: NftInfo[];
  size: number;
  hovered?: boolean;
}) => {
  if (nfts.length === 1) {
    return (
      <SquareNftImage
        imageUrl={nfts[0].image}
        name={nfts[0].name}
        size={size}
        rounded
      />
    );
  }

  const shownNfts = nfts.slice(0, SHOWN_NFTS_COUNT);

  return (
    <div className="nft-stack" style={{ width: size, height: size }}>
      {shownNfts.map((nft, i) => (
        <div
          key={nft.api_id}
          className="nft animated"
          style={{
            zIndex: SHOWN_NFTS_COUNT - i,
            transform: hovered && i > 0 ? `translateY(-2px)` : undefined,
          }}
        >
          <div
            style={{
              // Move up by 16% of NFT size and make 20% smaller each time.
              transform: `translateY(-${i * size * 0.16}px) scale(${
                1 - i * 0.2
              })`,
            }}
          >
            <SquareNftImage
              imageUrl={nft.image}
              name={nft.name}
              size={size}
              rounded
            />
          </div>
        </div>
      ))}

      <style jsx>{`
        .nft-stack {
          display: grid;
        }

        .nft {
          grid-row: 1;
          grid-column: 1;
        }
      `}</style>
    </div>
  );
};

// This takes an array of NFTs and returns a name like "NFT Name + n others".
export const abbreviatedNftsLabel = (nfts: NftInfo[]): string => {
  if (nfts.length === 1) {
    return nfts[0].name;
  }

  if (nfts.length === 2) {
    return `${nfts[0].name} and ${nfts[1].name}`;
  }

  // "others" doesn't need to be pluralized because nfts.length === 2 has already been handled.
  return `${nfts[0].name} and ${nfts.length - 1} others`;
};
